module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 105.3d494d06.png";